import api from "../../config/client.axios.api";

export const getSolutionApi = async () => {
  const response = await api.get(`/solution`);
  return response.data;
};
